import angular from 'angular';
import { dateFormatFilter } from './dateFormatFilter';

angular.module('sh.dateFormat', []).filter('shDate', dateFormatFilter);
